import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TopNavbarComponent } from '../../parkifly-bookings/organizations/components/top-navbar/top-navbar.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { UpperCasePipe, CommonModule } from '@angular/common';
import { MyConfigService } from '../../services/my-config.service';
import { AuthService } from '../../services/auth.service';
import { CheckboxComponent } from '../../parkifly-bookings/components/checkbox/checkbox.component';
import { SelfServiceService } from '../../services/self-service.service';
import { BookingConfigService } from '../../parkifly-bookings/services/booking-config.service';
import { CheckoutServices } from '../../parkifly-bookings/services/checkout.service';

@Component({
  selector: 'app-drive-in-booking',
  imports: [TopNavbarComponent, TranslocoModule, ReactiveFormsModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, MatInputModule, MatFormFieldModule, MatCheckboxModule, MatRadioModule, MatSelectModule, MatDatepickerModule, MatNativeDateModule, UpperCasePipe, CommonModule, CheckboxComponent, UpperCasePipe],
  templateUrl: './drive-in-booking.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './drive-in-booking.component.css'
})
export class DriveInBookingComponent {

  isLoading = false;
  showbookingDetailsForm = false;
  driveUpInputs: any = {};
  parkingFound: boolean = false;
  wrongParking: boolean = false;
  ParkingToBeCreated: boolean = false;
  minEndDate: Date = new Date();
  maxEndDate: Date = new Date();
  isEditingRegNo = false;
  timeoutError: boolean;
  showDetailsPage: boolean = false;
  showPaymentOption: boolean = false;
  parkings: any = {};
  parkingTo: string;
  parkingFrom: string;
  orderId: string = null;
  orgId = "";
  showRegInputField: boolean = true;;
  isPaymentCompleted = false;
  payexCreditcardUrl = '';
  payexSwishUrl = '';
  payexUrl = '';
  payexSwishLoaded = false;
  selectedPayment: string | null = null;
  correctParkingSite: '';
  componentDestroyed$: Subject<boolean> = new Subject();

  driveInBookingForm = new FormGroup({
    ordernumber: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    registrationNumber: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(9), Validators.pattern(/^[A-Z0-9]{4,9}$/)])
  });

  constructor(public translate: TranslocoService,
    public dialog: MatDialog,
    public myConfigService: MyConfigService,
    public authService: AuthService,
    private route: ActivatedRoute,
    private selfServiceService: SelfServiceService,
    private bookingconfig: BookingConfigService,
    public checkoutService: CheckoutServices,
    private router: Router
  ) {
    this.bookingconfig.setOrganization('skavsta');
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const gateId = params['g'];
      const licensePlate = params['l'];
      const status = params['status'];
      if (gateId && licensePlate) {
        this.driveUpInputs = {
          gateId: gateId,
          licensePlate: licensePlate,
          status: status
        };

        if (licensePlate) {
          this.driveInBookingForm.patchValue({
            registrationNumber: licensePlate
          });
        }

      } else if (!gateId && licensePlate) {
        this.showRegInputField = false;
        if (status == '3') {
          this.parkingFound = true;
          this.driveInBookingForm.patchValue({
            registrationNumber: licensePlate
          });
        }
      }
    });
  }

  resetdriveInBookingForm(): void {
    this.driveInBookingForm.reset();
    this.showbookingDetailsForm = false;
    this.showDetailsPage = false;
    this.parkingFound = false;
    this.wrongParking = false;
    this.ParkingToBeCreated = false;
    this.showPaymentOption = false;
    this.isEditingRegNo = true;
  }

  submitForm(): void {
    if (this.isLoading) return;

    this.isLoading = true;
    this.parkingFound = false;
    this.wrongParking = false;
    this.ParkingToBeCreated = false;
    this.showDetailsPage = false;
    const currentLicensePlate = this.driveInBookingForm.get('registrationNumber')?.value;

    this.selfServiceService.driveUpRegistration(this.driveUpInputs.gateId, currentLicensePlate).then((result) => {
      this.driveUpInputs.licensePlate = currentLicensePlate;
      this.isEditingRegNo = false;
      if (result.statusName == "FoundParking") {
        this.parkingFound = true;
      } else if (result.statusName == "WrongParking") {
        this.wrongParking = true;
        this.correctParkingSite = result.correctParkingSiteName;
      } else if (result.statusName == "DriveUpCreated") {
        this.driveUpInputs.parkingFrom = result.parkingFrom;
        this.driveUpInputs.parkingId = result.parkingId;
        this.driveUpInputs.orderId = result.orderId;
        this.driveUpInputs.orgId = result.organizationId;
        this.driveUpInputs.vehicleOwner = result.vehicleOwner || null;
        this.ParkingToBeCreated = true;
        this.goToBookingForm();
      }
    }).finally(() => {
      this.isLoading = false;
    });
  }

  goToBookingForm() {
    const queryParams: any = {
      l: this.driveInBookingForm.get('registrationNumber')?.value,
      parkingId: this.driveUpInputs.parkingId,
      parkingFrom: this.driveUpInputs.parkingFrom,
      orderId: this.driveUpInputs.orderId,
      orgId: this.driveUpInputs.orgId
    };
    if (this.driveUpInputs.vehicleOwner) {
      queryParams.vehicleOwner = JSON.stringify(this.driveUpInputs.vehicleOwner);
    }
    this.router.navigate(['/parkifly/drive-in-details-form'], {
      queryParams,
      state: {
        licensePlate: this.driveInBookingForm.get('registrationNumber')?.value,
        parkingId: this.driveUpInputs.parkingId,
        parkingFrom: this.driveUpInputs.parkingFrom,
        orderId: this.driveUpInputs.orderId,
        orgId: this.driveUpInputs.orgId,
        vehicleOwner: this.driveUpInputs.vehicleOwner
      }
    });
  }

  regToUpper(): void {
    const control = this.driveInBookingForm.get('registrationNumber');
    if (control?.value) {
      control.setValue(control.value.toUpperCase());
    }
  }

  updateUrlWithRegNumber(regNumber: string) {
    if (regNumber && regNumber.length > 0) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { l: regNumber.toUpperCase() },
        queryParamsHandling: 'merge'
      });
    }
    this.isEditingRegNo = false;
  }

  getFormattedRegNo(): string {
    const regNo = (this.driveInBookingForm.get('registrationNumber')?.value)?.toUpperCase();
    if (!regNo) return '';

    if (regNo.length === 6) {
      return `${regNo.substring(0, 3)} ${regNo.substring(3)}`;
    }
    return regNo;
  }

  enableRegNoEdit(): void {
    if (this.hasApiResponse()) return;
    this.isEditingRegNo = true;
    setTimeout(() => {
      const input = document.querySelector('#regInput') as HTMLInputElement;
      if (input) input.focus();
    });
  }

  hasApiResponse(): boolean {
    return this.parkingFound || this.wrongParking || this.ParkingToBeCreated;
  }

  disableRegNoEdit(): void {
    this.isEditingRegNo = false;
  }

}